import React from 'react';
import CommonField from '../ag_chart/components/CommonField.jsx';
import Select from '../../../common/Select.jsx';
import get from 'lodash/get';

function SelectSetting(props) {
  const { attr, label, prefix='', children, selectedObject, setAttribute, options, defaultValue, disabled = false, isClearable = true, isMulti = false } = props;
  const fullAttr = [prefix, attr].filter(Boolean).join('.');
  return (
    <CommonField label={label} {...props}>
      <Select defaultValue={defaultValue} options={options} value={get(selectedObject, fullAttr)} onChange={v => setAttribute(fullAttr, v)} disabled={disabled} isClearable={isClearable} isMulti={isMulti} />
      {children}
    </CommonField>
  )
}

export default SelectSetting;